import { EmployeeStatus } from '../enums/EmployeeStatus.enum';
import { IEmployeePaginationProps } from '../interfaces/employee/IEmployeePaginationProps';
import { IEmployee } from '../interfaces/IEmployee';
import { IEmployeeEmergencyContact } from '../interfaces/IEmployeeEmergencyContact';
import { IWorkingHours } from '../interfaces/IWorkingHours';
import { IElmDraftPromotionRequest } from '../interfaces/employee/IElmDraftPromotion';

export class LoadEmployee {
  static readonly type = '[Employee] LoadEmployee';

  constructor(public payload: { id: string }) {}
}

export class LoadEmergencyContacts {
  static readonly type = '[EmergencyContact] LoadEmergencyContacts';

  constructor(public payload: { id: string }) {}
}

export class LoadEmployees {
  static readonly type = '[Employee] LoadEmployees';

  constructor(public employeePaginationProps: IEmployeePaginationProps) {}
}

export class LoadAllEmployees {
  static readonly type = '[Employee] LoadAllEmployees';
}

export class LoadWorkingHours {
  static readonly type = '[Employee] LoadWorkingHours';

  constructor(public payload: { id: string }) {}
}

export class UpdateEmployee {
  static readonly type = '[Employee] UpdateEmployee';

  constructor(public employee: IEmployee) {}
}

export class UpdateWorkingHours {
  static readonly type = '[Employee] UpdateWorkingHours';

  constructor(public workingHours: IWorkingHours[]) {}
}

export class CreateEmployee {
  static readonly type = '[Employee] CreateEmployee';

  constructor(public employee: IEmployee) {}
}

export class CreateEmergencyContact {
  static readonly type = '[EmergencyContact] CreateEmergencyContact';

  constructor(public payload: { id: string; contact: IEmployeeEmergencyContact }) {}
}

export class UpdateEmergencyContact {
  static readonly type = '[EmergencyContact] UpdateEmergencyContact';

  constructor(public payload: { id: string; contact: IEmployeeEmergencyContact }) {}
}

export class DeleteEmergencyContact {
  static readonly type = '[EmergencyContact] DeleteEmergencyContact';

  constructor(public payload: { id: string; emergencyContactId: string }) {}
}

export class ClearEmergencyContactsAndWorkingHours {
  static readonly type = '[Employee] ClearEmergencyContactsAndWorkingHours';
}

export class CheckEmployeeStatus {
  static readonly type = '[Employee] CheckEmployeeStatus';
  public result: EmployeeStatus | null = null;

  constructor(public gid: string) {}
}

export class ResolveOnboardingEmployee {
  static readonly type = '[Employee] ResolveOnboardingEmployee';

  constructor(public gid: string) {}
}

export class ClearOnboardingEmployeeStatus {
  static readonly type = '[Employee] Clear Onboarding Employee Status';
}

export class PromoteElmDraft {
  static readonly type = '[Employee] PromoteElmDraft';

  constructor(public readonly request: IElmDraftPromotionRequest) {}
}
